import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/backend";
import { extractionWrapper } from "../extract";

/**
 * Hook to fetch organization settings including revokePeriod for applications.
 *
 * This provides access to organization-wide settings like the application revoke period (how many
 * days before a shift can an employee revoke their application).
 */
export function useOrganizationSettings() {
  return useQuery({
    queryKey: ["organization-settings"],
    queryFn: async () => {
      const result = await extractionWrapper(api.organization.getMyOrganization());
      return result;
    },
    staleTime: 60000, // 1 minute
    gcTime: 300000, // 5 minutes
  });
}
